<template>
  <div style="max-width: 1200px;" class="mx-auto px-12" id="purchase-order">
    <div class="text-center display-2 primary--text">
      <h2 class="pt-5">BON DE COMMANDE</h2>
    </div>
    <v-row class="border-around">
      <v-col cols="6" class="border-left">
        <v-simple-table class="table-contact px-12">
          <tbody>
            <tr>
              <td colspan="2">
                <v-img src="assets/img/logo-eduniversal.png" width="154" class="mb-4" />
              </td>
            </tr>
            <tr>
              <td colspan="2">
                Contact
                <strong class="primary--text">Eduniversal</strong>
              </td>
            </tr>
            <tr>
              <td>
                <v-icon v-text="'$user'" class="mr-2"></v-icon>
                <strong>Nom :</strong>
              </td>
              <td>Florian</td>
            </tr>
            <tr>
              <td>
                <v-icon v-text="'$telephone'" class="mr-2"></v-icon>
                <strong>Téléphone :</strong>
              </td>
              <td>0123xxxxxx</td>
            </tr>
            <tr>
              <td>
                <v-icon v-text="'$email'" class="mr-2"></v-icon>
                <strong>E-mail :</strong>
              </td>
              <td>Florian@xxxx.com</td>
            </tr>
            <tr>
              <td>
                <v-icon v-text="'$map_marker'" class="mr-2"></v-icon>
                <strong>Adresse :</strong>
              </td>
              <td>19 boulevard des Nations Unies 92190 Meudon</td>
            </tr>
          </tbody>
        </v-simple-table>

        <div class="table-line"></div>
      </v-col>
      <v-col cols="6" class="border-right">
        <v-simple-table class="table-contact px-12">
          <tbody>
            <tr>
              <td colspan="2">
                <v-img src="assets/img/logo-financia.png" height="58" max-width="190" class="mb-4" />
              </td>
            </tr>
            <tr>
              <td colspan="2">
                Contact
                <strong class="primary--text">Financia Business School</strong>
              </td>
            </tr>
            <tr>
              <td>
                <v-icon v-text="'$user'" class="mr-2"></v-icon>
                <strong>Nom :</strong>
              </td>
              <td>Giao Nguyen</td>
            </tr>
            <tr>
              <td>
                <v-icon v-text="'$telephone'" class="mr-2"></v-icon>
                <strong>Téléphone :</strong>
              </td>
              <td>0123xxxxxx</td>
            </tr>
            <tr>
              <td>
                <v-icon v-text="'$email'" class="mr-2"></v-icon>
                <strong>E-mail :</strong>
              </td>
              <td>giaonguyen@xxxx.com</td>
            </tr>
            <tr>
              <td>
                <v-icon v-text="'$map_marker'" class="mr-2"></v-icon>
                <strong>Adresse :</strong>
              </td>
              <td>37 Ky Con, Ward Nguyen Thai Binh, District 1, HCM</td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <h3 class="heading">INFORMATION</h3>
      </v-col>
      <v-col cols="4">
        <h4>Pays</h4>
        <p>France, Italie, Espagne</p>
        <h4>Region</h4>
        <p>Bretagne, Nord</p>
        <h4>Canaux</h4>
        <p>Email, Portable, Push Notif, Postal</p>
      </v-col>

      <v-col cols="4">
        <h4>Niveau</h4>
        <p>Bac+2</p>
        <h4>Diplome</h4>
        <p>Bachelor</p>
      </v-col>

      <v-col cols="4">
        <h4>Specialite etudier</h4>
        <p>Ntic - Informatique - Réseaux, Banque - Finance, Logistique</p>
        <h4>Choix de poursuite d'etudes</h4>
        <p>PRIX SPÉCIAUX, Achats</p>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card flat ref="form" class="mt-0">
          <v-data-table
            :headers="tableHeaders"
            :items="desserts"
            hide-default-footer
            class="table-result elevation-0"
            style="overflow-x:auto"
          >
            <template v-slot:body.append>
              <tr class="infor-table-bottom">
                <td class="empty-td"></td>
                <td class="text-start">Tarif HT</td>
                <td></td>
                <td>653.72</td>
              </tr>
              <tr class="infor-table-bottom">
                <td class="empty-td"></td>
                <td class="text-start">Discount</td>
                <td>5%</td>
                <td>32.69</td>
              </tr>
              <tr class="infor-table-bottom">
                <td class="empty-td"></td>
                <td class="text-start">Total HT</td>
                <td></td>
                <td>621.03</td>
              </tr>
              <tr class="infor-table-bottom">
                <td class="empty-td"></td>
                <td class="text-start">Total TTC</td>
                <td>20%</td>
                <td>745.24</td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <v-row class="pb-8">
      <v-col cols="6">
        <p>Merci de compléter les documents ci-joint</p>
      </v-col>
      <v-spacer></v-spacer>
      <v-col class="text-center">
        <p>Signature, date et cachet</p>
        <p><strong>BON POUR ACCORD</strong></p>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="pt-12 mt-12 text-center">
        <p class="pt-12 pb-2"><strong>Editeur de la Collection Guid'Formation et des sites www.guidformation.com Propriétaire d'une Base de Données de 18-25 ans</strong></p>
        <p>EDUNIVERSAL – SA au Capital de 568 897.25 € – 19 Boulevard des Nations Unies – 92190 Meudon SIRET 399 207 729 00050 – RCS Nanterre - APE 8899B – TVA FR 89 399 207 729</p>
      </v-col>
    </v-row>
  </div>
</template>
<script>
export default {
  name: "ExportPurchaseOrder",
  data: () => ({
    tableHeaders: [
      {
        text: "",
        sortable: false,
        value: "name"
      },
      {
        text: "",
        sortable: false,
        value: "calories"
      },
      {
        text: "Prix U",
        align: "center",
        sortable: false,
        value: "prix"
      },
      {
        text: "Total",
        align: "center",
        sortable: false,
        value: "total"
      }
    ],
    desserts: [
      {
        name: "Email",
        calories: 1259,
        prix: 0.23,
        total: 289.57
      },
      {
        name: "SMS",
        calories: 899,
        prix: 0.21,
        total: 188.79
      },
      {
        name: "Push notification App",
        calories: 1259,
        prix: 0.23,
        total: 289.57
      },
      {
        name: "Push notification Navigateur",
        calories: 1259,
        prix: 0.23,
        total: 289.57
      },
      {
        name: "Frais Fixe comptage et export",
        calories: 1259,
        prix: 0.23,
        total: 289.57
      },
      {
        name: "Frais de routage E-mail",
        calories: 1259,
        prix: 0.23,
        total: 289.57
      },
      {
        name: "Frais de routage SMS",
        calories: 1259,
        prix: 0.23,
        total: 289.57
      },
      {
        name: "Frais de routage Push Notif",
        calories: 1259,
        prix: 0.23,
        total: 289.57
      }
    ]
  })
};
</script>

